import { useReceiptReducer } from "./UseReceiptReducer";
import { validarReceipt } from "../validations/receipt.validations";
import { construirPayload } from "../utils/ConstruirPayload";
import { getTotalRecibo } from "../selectors/receipt.selectors";
import { UrlApi } from "../../../../../../../services/apirest";

const UseReceipt = () => {
  const { state, dispatch } = useReceiptReducer();

  const validar = () => validarReceipt(state);

  const confirm = async (
    previewData,
    { valorMaximoRedondeo, onSuccess, onWarning, onError },
  ) => {
    const response = await fetch(UrlApi + "/ctacte/recibos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(previewData),
    });

    const data = await response.json();
    console.log("Redondeo: ", data);
    console.log("RedondeoRealG: ", data.redondeo);
    console.log("valorMAximo del redondeo: ", valorMaximoRedondeo);
    console.log(Number(data.redondeo) > Number(valorMaximoRedondeo));

    if (!response.ok) {
      const msg =
        data?.msg ||
        data?.message ||
        data?.error ||
        "Error al guardar el recibo";
      const error = new Error(msg);
      error.status = response.status;
      error.codigo = data?.codigo ?? null;
      if (
        response.status === 409 &&
        (data?.codigo === "lista_negra" ||
          data?.codigo === "cuit_bloqueado" ||
          /lista negra|emisores bloqueados|cuit bloqueado/i.test(String(msg)))
      ) {
        error.message =
          msg ||
          "El CUIT firmante del cheque está bloqueado en lista negra de emisores.";
      }
      throw error;
    }

    if (Number(data.redondeo) > Number(valorMaximoRedondeo)) {
      onWarning?.("El recibo quedó en estado pendiente por redondeo alto");
    } else {
      onSuccess?.("El recibo se guardó con éxito!");
    }

    reset();
  };

  const getPayload = () => {
    const formData = {
      // Datos del recibo
      clienteCuit: state.recibo.clienteCuit,
      numCliente: state.recibo.numCliente,
      FechaDePago: state.recibo.FechaDePago,
      numRecibo: state.recibo.numRecibo,
      usaReciboElectronico: state.recibo.usaReciboElectronico,
      efectivo: state.recibo.efectivo,
      redondeo: state.recibo.redondeo,
      totalEsperado: state.recibo.totalEsperado,
      idCliente: state.recibo.idCliente,
      idTipoNegocio: state.recibo.idTipoNegocio,

      // Retenciones
      retSuss: state.retenciones.retSuss,
      retIva: state.retenciones.retIva,
      retGanancias: state.retenciones.retGanancias,
      retDrei: state.retenciones.retDrei,
      retencionesIIBB: state.retenciones.retencionesIIBB,

      // Arrays
      instrumentos: state.instrumentos,
      tarjetas: state.tarjetas,
      imputaciones: state.imputaciones,

      // Total calculado
      totalCobrado: getTotalRecibo(state),
    };

    return construirPayload(formData);
  };

  const reset = () => dispatch({ type: "RESET" });

  const submit = () => {
    const result = validar();

    if (!result.isValid) {
      return { ok: false, errors: result.errors };
    }

    const payload = getPayload();
    // console.log("Estoy ejecutando codigo en el useReceipt.");
    // reset();
    return { ok: true, payload };
  };

  const updateRecibo = (field, value) => {
    dispatch({ type: "RECIBO_UPDATE", field, value });
  };

  const updateFechaDePago = (field, value) => {
    dispatch({ type: "RECIBO_FECHA_UPDATE", field, value });
  };

  const updateNumRecibo = (field, value) => {
    dispatch({ type: "RECIBO_NUMERO_UPDATE", field, value });
  };

  const updateRetencion = (field, value) => {
    dispatch({ type: "RETENCION_UPDATE", field, value });
  };

  const addIIBB = () => dispatch({ type: "ADD_IIBB" });

  const updateIIBB = (index, field, value) => {
    dispatch({ type: "UPDATE_IIBB", index, field, value });
  };

  const removeIIBB = (index) => {
    dispatch({ type: "REMOVE_IIBB", index });
  };

  const addInstrumento = () => dispatch({ type: "ADD_INSTRUMENTO" });

  const updateInstrumento = (index, field, value) => {
    dispatch({ type: "UPDATE_INSTRUMENTO", index, field, value });
  };

  const removeInstrumento = (index) => {
    dispatch({ type: "REMOVE_INSTRUMENTO", index });
  };

  const addInstrumentosQr = (creditos) => {
    dispatch({ type: "ADD_INSTRUMENTOS_QR", creditos });
  };

  const addTarjeta = () => dispatch({ type: "ADD_TARJETA" });

  const updateTarjeta = (index, field, value) => {
    dispatch({ type: "UPDATE_TARJETA", index, field, value });
  };

  const removeTarjeta = (index) => {
    dispatch({ type: "REMOVE_TARJETA", index });
  };

  const addImputacion = () => dispatch({ type: "ADD_IMPUTACION" });

  const updateImputacion = (index, field, value) => {
    dispatch({ type: "UPDATE_IMPUTACION", index, field, value });
  };

  const removeImputacion = (index) => {
    dispatch({ type: "REMOVE_IMPUTACION", index });
  };

  const setImputaciones = (imputaciones) => {
    dispatch({ type: "SET_IMPUTACIONES", imputaciones });
  };

  return {
    state,
    dispatch,
    submit,
    confirm,
    updateRecibo,
    updateFechaDePago,
    updateNumRecibo,
    updateRetencion,
    addIIBB,
    updateIIBB,
    removeIIBB,
    addInstrumento,
    updateInstrumento,
    removeInstrumento,
    addInstrumentosQr,
    addTarjeta,
    updateTarjeta,
    removeTarjeta,
    addImputacion,
    updateImputacion,
    removeImputacion,
    setImputaciones,
    reset,
  };
};

export default UseReceipt;
